import { AipLogDetail, AipLogListResult, AipSummary, AipTrend } from '../models/dashboard/aip/AipMonitoring';
import { BaseService } from './BaseService';

export class DashboardService extends BaseService {
  /**
   * 기간 쿼리 문자열. companyCode를 넘기면 해당 회사만 조회한다.
   * refresh를 true로 주면 서버가 캐시를 무시하고 새로 조회한다(새로고침 버튼).
   */
  private readonly periodQuery = (from: string, to: string, companyCode?: string, refresh?: boolean) => {
    const base = `from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
    const withCompany = companyCode ? `${base}&companyCode=${encodeURIComponent(companyCode)}` : base;
    return refresh ? `${withCompany}&refresh=true` : withCompany;
  };

  /**
   * [AIP] - KPI 카드 + 출처별 집계
   */
  public getAipSummaryAsync = async (
    from: string,
    to: string,
    companyCode?: string,
    refresh?: boolean,
  ): Promise<AipSummary> => {
    return await this.getResponseAsync<AipSummary>({
      commandPath: `api/dashboard/aip/summary?${this.periodQuery(from, to, companyCode, refresh)}`,
      method: 'GET',
    });
  };

  /**
   * [AIP] - 업로드 건수 추이.
   */
  public getAipTrendAsync = async (
    from: string,
    to: string,
    companyCode?: string,
    refresh?: boolean,
  ): Promise<AipTrend> => {
    return await this.getResponseAsync<AipTrend>({
      commandPath: `api/dashboard/aip/trend?${this.periodQuery(from, to, companyCode, refresh)}`,
      method: 'GET',
    });
  };

  /**
   * [AIP] - 업로드 상세 목록(최신순, 페이징)
   */
  public getAipLogsAsync = async (
    from: string,
    to: string,
    page: number,
    pageSize: number,
    companyCode?: string,
    refresh?: boolean,
  ): Promise<AipLogListResult> => {
    return await this.getResponseAsync<AipLogListResult>({
      commandPath: `api/dashboard/aip/logs?${this.periodQuery(from, to, companyCode, refresh)}&page=${page}&pageSize=${pageSize}`,
      method: 'GET',
    });
  };

  /**
   * [AIP] - 업로드 상세(단건) — 상세보기 팝업
   */
  public getAipLogDetailAsync = async (userId: string, rowKey: string): Promise<AipLogDetail> => {
    return await this.getResponseAsync<AipLogDetail>({
      commandPath: `api/dashboard/aip/logs/${encodeURIComponent(userId)}/${encodeURIComponent(rowKey)}`,
      method: 'GET',
    });
  };
}
